import { createRouter, createWebHashHistory, RouteRecordRaw } from "vue-router";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    redirect: "/dashboardView",
    name: "home",
    component: () =>
      import(/* webpackChunkName: "home" */ "@/views/IndexView.vue"),
    children: [
      {
        path: "dashboardView",
        name: "首页",
        component: () =>
          import(
            /* webpackChunkName: "dashboardView"  */ "@/views/workplace/index.vue"
          )
      },
      /***** 人口管理 *****/
      {
        path: "residentPopulationView",
        name: "常住人口管理",
        component: () =>
          import(
            /* webpackChunkName: "residentPopulationView"  */ "@/views/PopulationManagement/ResidentPopulationView.vue"
          )
      },
      {
        path: "residentPopulationInfoView",
        name: "residentPopulationInfoView",
        component: () =>
          import(
            /* webpackChunkName: "residentPopulationInfoView"  */ "@/views/PopulationManagement/ResidentPopulationInfoView.vue"
          )
      },
      {
        path: "floatingPopulationView",
        name: "流动人口管理",
        component: () =>
          import(
            /* webpackChunkName: "floatingPopulationView"  */ "@/views/PopulationManagement/FloatingPopulationView.vue"
          )
      },
      {
        path: "HistoricalTenantView",
        name: "历史租客",
        component: () =>
          import(
            /* webpackChunkName: "floatingPopulationView"  */ "@/views/PopulationManagement/HistoricalTenantView.vue"
          )
      },
      {
        path: "partyManagementView",
        name: "党员管理",
        component: () =>
          import(
            /* webpackChunkName: "partyManagementView"  */ "@/views/PopulationManagement/PartyManagementView.vue"
          )
      },
      {
        path: "partyManagementInfoView",
        name: "partyManagementInfoView",
        component: () =>
          import(
            /* webpackChunkName: "partyManagementInfoView"  */ "@/views/PopulationManagement/PartyManagementInfoView.vue"
          )
      },
      {
        path: "internetCelebrityView",
        name: "网红主播管理",
        component: () =>
          import(
            /* webpackChunkName: "internetCelebrityView"  */ "@/views/PopulationManagement/InternetCelebrityView.vue"
          )
      },
      {
        path: "internetCelebrityInfoView",
        name: "internetCelebrityInfoView",
        component: () =>
          import(
            /* webpackChunkName: "InternetCelebrityInfoView"  */ "@/views/PopulationManagement/InternetCelebrityInfoView.vue"
          )
      },
      /***** 房屋管理 *****/
      {
        path: "housePopulationView",
        name: "房屋管理",
        component: () =>
          import(
            /* webpackChunkName: "HousePopulationView"  */ "@/views/HouseManagement/HousePopulationView.vue"
          )
      },
      {
        path: "housePopulationDetailView",
        name: "房屋详情",
        component: () =>
          import(
            /* webpackChunkName: "HousePopulationView"  */ "@/views/HouseManagement/HousePopulationDetailsView.vue"
          )
      },
      {
        path: "shopPopulationView",
        name: "商铺管理",
        component: () =>
          import(
            /* webpackChunkName: "shopPopulationView"  */ "@/views/HouseManagement/ShopPopulationView.vue"
          )
      },
      {
        path: "shopPopulationInfoView",
        name: "shopPopulationInfoView",
        component: () =>
          import(
            /* webpackChunkName: "shopPopulationInfoView"  */ "@/views/HouseManagement/ShopPopulationInfoView.vue"
          )
      },
      {
        path: "scheduledAuditView",
        name: "预约审核",
        component: () =>
          import(
            /* webpackChunkName: "scheduledAuditView"  */ "@/views/HouseManagement/StudioManagement/ScheduledAuditView.vue"
          )
      },
      {
        path: "studioManagementView",
        name: "直播间管理",
        component: () =>
          import(
            /* webpackChunkName: "studioManagementView"  */ "@/views/HouseManagement/StudioManagement/StudioManagementView.vue"
          )
      },
      {
        path: "studioManagementInfoView",
        name: "studioManagementInfoView",
        component: () =>
          import(
            /* webpackChunkName: "studioManagementInfoView"  */ "@/views/HouseManagement/StudioManagement/StudioManagementInfoView.vue"
          )
      },

      /***** 网格管理 *****/
      {
        path: "gridManagementView",
        name: "网格管理",
        component: () =>
          import(
            /* webpackChunkName: "gridManagementView"  */ "@/views/GridManagement/GridManagementView.vue"
          )
      },
      /***** 车辆管理 *****/
      {
        path: "carManagementView",
        name: "车辆管理",
        component: () =>
          import(
            /* webpackChunkName: "carManagementView"  */ "@/views/CarManagement/CarManagementView.vue"
          )
      },
      /***** 智慧党建 *****/
      {
        path: "partyBuildingInformationView",
        name: "智慧党建",
        component: () =>
          import(
            /* webpackChunkName: "partyBuildingInformationView"  */ "@/views/PartyBuildManagement/PartyBuildingInformationView.vue"
          )
      },
      {
        path: "publishingConsultationView",
        name: "publishingConsultationView",
        component: () =>
          import(
            /* webpackChunkName: "publishingConsultationView"  */ "@/views/PartyBuildManagement/PublishingConsultationView.vue"
          )
      },
      {
        path: "publishingConsultationInfoView",
        name: "publishingConsultationInfoView",
        component: () =>
          import(
            /* webpackChunkName: "publishingConsultationInfoView"  */ "@/views/PartyBuildManagement/PublishingConsultationInfoView.vue"
          )
      },
      {
        path: "goodPeopleView",
        name: "好人好事",
        component: () =>
          import(
            /* webpackChunkName: "goodPeopleView"  */ "@/views/PartyBuildManagement/GoodPeopleView.vue"
          )
      },
      {
        path: "categoryView",
        name: "资讯分类",
        component: () =>
          import(
            /* webpackChunkName: "categoryView"  */ "@/views/PartyBuildManagement/CategoryView.vue"
          )
      },
      {
        path: "partyBuildingPropagandaView",
        name: "党建宣传",
        component: () =>
          import(
            /* webpackChunkName: "partyBuildingPropagandaView"  */ "@/views/PartyBuildManagement/PartyBuildingPropagandaView.vue"
          )
      },
      {
        path: "comprehensiveInformationView",
        name: "综合资讯",
        component: () =>
          import(
            /* webpackChunkName: "comprehensiveInformationView"  */ "@/views/PartyBuildManagement/ComprehensiveInformationView.vue"
          )
      },
      {
        path: "villageHistoryView",
        name: "村史民约",
        component: () =>
          import(
            /* webpackChunkName: "villageHistoryView"  */ "@/views/PartyBuildManagement/VillageHistoryView.vue"
          )
      },
      {
        path: "serviceConsultationView",
        name: "服务咨询",
        component: () =>
          import(
            /* webpackChunkName: "serviceConsultationView"  */ "@/views/PartyBuildManagement/ServiceConsultationView.vue"
          )
      },
      {
        path: "partyCommitteeView",
        name: "党委成员",
        component: () =>
          import(
            /* webpackChunkName: "partyCommitteeView"  */ "@/views/PartyBuildManagement/PartyCommitteeView.vue"
          )
      },

      /***** 通知管理 *****/
      {
        path: "commonManagementView",
        name: "普通通知",
        component: () =>
          import(
            /* webpackChunkName: "commonManagementView"  */ "@/views/MessageManagement/CommonManagementView.vue"
          )
      },
      {
        path: "commonManagementInfoView",
        name: "commonManagementInfoView",
        component: () =>
          import(
            /* webpackChunkName: "commonManagementInfoView"  */ "@/views/MessageManagement/CommonManagementInfoView.vue"
          )
      },
      {
        path: "birthdayWishesView",
        name: "生日祝福",
        component: () =>
          import(
            /* webpackChunkName: "birthdayWishesView"  */ "@/views/MessageManagement/BirthdayWishesView.vue"
          )
      },

      /***** 二户主管理 *****/
      {
        path: "secondPopHeadManagementView",
        name: "二户主管理",
        component: () =>
          import(
            /* webpackChunkName: "secondPopHeadManagementView"  */ "@/views/SecondPopHeadManagement/SecondPopHeadManagementView.vue"
          )
      },

      /***** 积分管理 *****/
      {
        path: "pointStatisticsView",
        name: "积分统计",
        component: () =>
          import(
            /* webpackChunkName: "pointStatisticsView"  */ "@/views/PointManagement/PointStatisticsView.vue"
          )
      },
      {
        path: "pointSettingView",
        name: "积分设置",
        component: () =>
          import(
            /* webpackChunkName: "pointSettingView"  */ "@/views/PointManagement/PointSettingView.vue"
          )
      },

      {
        path: "PointDetailView",
        name: "积分详情",
        component: () =>
          import(
            /* webpackChunkName: "pointSettingView"  */ "@/views/PointManagement/PointDetailsView.vue"
          )
      },

      //灭火器管理
      {
        path: "FireExtinguisherView",
        name: "灭火器管理",
        component: () =>
          import(
            /* webpackChunkName: "pointSettingView"  */ "@/views/FireExtinguisher/FireExtinguisherView.vue"
          )
      },

      {
        path: "FireSettingsView",
        name: "到期提醒设置",
        component: () =>
          import(
            /* webpackChunkName: "pointSettingView"  */ "@/views/FireExtinguisher/FireSettingsView.vue"
          )
      },

      //信息发布
      {
        path: "InformationReleaseView",
        name: "信息发布",
        component: () =>
          import(
            /* webpackChunkName: "pointSettingView"  */ "@/views/InformationRelease/InformationReleaseView.vue"
          )
      },

      // 热线管理

      {
        path: "HotlineView",
        name: "热线管理",
        component: () =>
          import(
            /* webpackChunkName: "pointSettingView"  */ "@/views/Hotline/HotlineView.vue"
          )
      },

      //随手拍
      {
        path: "ThenShoot",
        name: "随手拍管理",
        component: () =>
          import(
            /* webpackChunkName: "pointSettingView"  */ "@/views/ThenShoot/ThenShootView.vue"
          )
      },

      // 资讯管理
      {
        path: "InformationView",
        name: "资讯管理",
        component: () =>
          import(
            /* webpackChunkName: "pointSettingView"  */ "@/views/Information/InformationView.vue"
          )
      },

      {
        path: "InformationTypeView",
        name: "资讯分类",
        component: () =>
          import(
            /* webpackChunkName: "pointSettingView"  */ "@/views/Information/InformationTypeView.vue"
          )
      },

      {
        path: "InformationSaveView",
        name: "发布资讯",
        component: () =>
          import(
            /* webpackChunkName: "pointSettingView"  */ "@/views/Information/SaveInformationView.vue"
          )
      },

      {
        path: "InformationDetailView",
        name: "资讯详情",
        component: () =>
          import(
            /* webpackChunkName: "pointSettingView"  */ "@/views/Information/InformationDetailsView.vue"
          )
      },

      //活动管理
      {
        path: "ActivityView",
        name: "活动管理",
        component: () =>
          import(
            /* webpackChunkName: "pointSettingView"  */ "@/views/ActivityManagement/ActivityManagementView.vue"
          )
      },

      {
        path: "ActivityEditView",
        name: "创建活动",
        component: () =>
          import(
            /* webpackChunkName: "pointSettingView"  */ "@/views/ActivityManagement/ActivityManagementEditView.vue"
          )
      },

      {
        path: "ActivityDetailsView",
        name: "活动详情",
        component: () =>
          import(
            /* webpackChunkName: "pointSettingView"  */ "@/views/ActivityManagement/ActivityManagementDetailsView.vue"
          )
      },

      /***** 系统管理 *****/
      {
        path: "CarouseView",
        name: "轮播图设置",
        component: () =>
          import(
            /* webpackChunkName: "platformSettingsView"  */ "@/views/SystemManagement/CarouselView.vue"
          )
      },
      {
        path: "platformSettingsView",
        name: "平台信息设置",
        component: () =>
          import(
            /* webpackChunkName: "platformSettingsView"  */ "@/views/SystemManagement/PlatformSettingsView.vue"
          )
      },
      {
        path: "adminView",
        name: "管理员设置",
        component: () =>
          import(/* webpackChunkName: "adminView"  */ "@/views/SystemManagement/AdminView.vue")
      },
      {
        path: "roleView",
        name: "角色权限",
        component: () =>
          import(/* webpackChunkName: "roleView"  */ "@/views/SystemManagement/RoleView.vue")
      },

      /***** 更多资讯 *****/
      {
        path: "dataMoreView",
        name: "党建资讯",
        component: () =>
          import(/* webpackChunkName: "dataMoreView"  */ "@/views/Homepage/DataPartyBuildingComponents/DataMoreView.vue")
      },
      {
        path: "dataMoreInfoView",
        name: "更多资讯",
        component: () =>
          import(/* webpackChunkName: "dataMoreInfoView"  */ "@/views/Homepage/DataPartyBuildingComponents/DataMoreInfoView.vue")
      }
    ]
  },
  {
    path: "/dataView",
    redirect: "/DataOverallView", //后期换成总览
    name: "驾驶舱",
    component: () =>
      import(/* webpackChunkName: "dataView"  */ "@/views/Homepage/DataView.vue"),
    children: [
      {
        path: "/DataPartyBuildingView",
        name: "党建数据",
        component: () =>
          import(
            /* webpackChunkName: "dataPartyBuildingView"  */ "@/views/Homepage/DataPartyBuildingView.vue"
          )
      },
      {
        path: "/DataPopulationView",
        name: "人口数据",
        component: () =>
          import(
            /* webpackChunkName: "dataPopulationView"  */ "@/views/Homepage/DataPopulationView.vue"
          )
      },
      {
        path: "/DataHouseView",
        name: "房屋数据",
        component: () =>
          import(
            "@/views/Homepage/DataHouseView.vue"
          )
      },
      {
        path: "/DataFireView",
        name: "智慧消防",
        component: () =>
          import(
            "@/views/Homepage/DataFireView.vue"
          )
      },
      {
        path: "/DataOverallView",
        name: "总览",
        component: () =>
          import(
            "@/views/Homepage/DataOverallView.vue"
          )
      }
    ]
  },
  {
    path: "/login",
    name: "login",
    component: () =>
      import(/* webpackChunkName: "login" */ "@/views/LoginView.vue")
  }
];

const router = createRouter({
  history: createWebHashHistory(), //createWebHistory(process.env.BASE_URL),
  routes
});
// export function resetRouter() {
//   let routers = router.getRoutes();
//   routers.map((it) => {
//     router.removeRoute(it.name!);
//   });
// }

export default router;
